
  import Vue from "vue";
  import PwaCompetitionRoundMatchResultUserBox from "@/components/competitions/PwaCompetitionRounds/PwaCompetitionRoundMatchResultUserBox.vue";
  import {ROUTES} from "@/router/routes";

  export default Vue.extend({
    name: "pwa-competition-round-match-result",
    components: {
      PwaCompetitionRoundMatchResultUserBox,
    },
    props: {
      result: {
        type: Object,
        required: true,
      },
      competitionStatusId: {
        type: Number,
        required: true,
      },
      competitionId: {
        type: Number,
        required: true,
      },
    },
    computed: {
      player1(): Record<string, any> {
        return this.result.player_1 && !Array.isArray(this.result.player_1) ? this.result.player_1 : {};
      },
      player2(): Record<string, any> {
        return this.result.player_2 && !Array.isArray(this.result.player_2) ? this.result.player_2 : {};
      },
    },
    methods: {
      goToCompetitionMatch() {
        if (this.player1.user_id && this.player2.user_id) {
          const competitionId: any = this.competitionId;
          const matchId: any = this.result.match_id;
          this.$router.push({name: ROUTES.competitionMatch.name,
            params: {
              lang: this.routeLang,
              competitionId,
              matchId,
              resultMatch: this.result,
            }
          });
        }
      },
    },
  });
